<template>
  <div class="two-intro">
    <p>
      <span class="caps">C</span>omme à l’accoutumée, vous attendez le début de soirée pour vous rendre chez
      votre voisine du tout dernier étage, Carmen, qui n'ouvre jamais sa porte avant la tombée de
      la nuit. Elle a entendu parler du meurtre et n'est pas surprise de vous voir débarquer chez
      elle.
    </p>
    <p>
      Vous lui faites rapidement le compte-rendu de la situation : le nom du coupable
      comporte cinq lettres, vous avez déjà la dernière, et vous avez besoin de son aide pour
      récupérer les quatre manquantes, dans l'ordre, en commençant par la première.
    </p>
    <p>
      Vous vous mettez au travail sans tarder. Vous donnez la photographie de la scène de
      crime à Carmen qui la dépose à côté de sa boule de cristal. Elle ferme les yeux, et
      commence à psalmodier ses étranges incantations. Vous jurez sentir l'air vibrer, et vous
      découvrez une nouvelle fois la puissance des pouvoirs de la bohémienne : un à un, des symboles apparaissent dans l'orbe, de couleur rouge, tels des tâches de sang.
    </p>
  </div>
</template>
<script>
export default {
  name: "TwoIntro"
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.two-intro {
  padding: 10% 10%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 80%;
}
.caps {
  color: rgba(0, 0, 0, 0.7);
  float: left;
  font-size: 110px;
  line-height: 0.8em;
  padding-right: 12px;
  position: relative;
  top: 8px;
}
</style>